// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__qM2ME","rootSmall":"AddTileButton_rootSmall__26Ugh"};